import {setCentreMessage} from '../actions';
import * as ActionTypes from '../actions/actionTypes';

export const orchestrateIndicators = store => next => action => {

  // First complete the current action
  const result = next(action);

  switch (action.type) {

    case ActionTypes.SWITCH_ACTIVE_INDICATOR:
      const activeIndicator = store.getState().indicators.active;
      if (activeIndicator && activeIndicator.warning) {
        store.dispatch(setCentreMessage(activeIndicator.warning, 'INDICATOR WARNING', true));
      }
      break;

    default:
      break;
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/middleware/indicatorsMiddleware.js